import {Component, EventEmitter, Input, Output} from "@angular/core";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'app-base-edit-bpmn-decision',
  templateUrl: './base-edit-bpmn-decision.component.html',
  styleUrls: ['./base-edit-bpmn-decision.component.scss']
})
export class BaseEditBpmnDecisionComponent {
  @Input() formGroupParent: FormGroup;
  @Input() formName: string;
  @Input() typeDecision: any;
  @Input() arrDecision: any;
  @Output() valueChange = new EventEmitter();
  @Output() getDataChange = new EventEmitter();

  constructor() {

  }
}
